import React, { useState } from 'react'
import Header from '../common/header'
import styled from 'styled-components'
import Footer from '../common/footer'
import { html as appPrivacy } from './privacy-app.md'
import { html as websitePrivacy } from './privacy-website.md'
import Spacer from '../lib/spacer'
import { useTranslation } from '../lib/i18n'
import LegalNotice from '../common/legal_notice'

const Wrapper = styled.div``

const Tabs = styled.div`
    display: flex;
    gap: 0;
    border-bottom: 2px solid #e0e0e0;
`

const Tab = styled.button`
    width: 160px;
    text-align: center;
    padding: 12px 0;
    border: none;
    background: none;
    font-size: 16px;
    font-weight: ${({ active }) => (active ? '600' : '400')};
    color: ${({ active }) => (active ? '#333' : '#888')};
    cursor: pointer;
    border-bottom: 2px solid ${({ active }) => (active ? '#333' : 'transparent')};
    margin-bottom: -2px;
    transition: color 0.2s ease, border-color 0.2s ease;

    &:hover {
        color: #333;
    }
`

const Updated = styled.p`
    font-size: 14px;
    color: #888;
`

export default () => {
    const [tab, setTab] = useState('app')
    const { t } = useTranslation()

    return (
        <>
            <Header />
            <Spacer className="show-for-large" size={60} />
            <Spacer className="hide-for-large" size={30} />
            <div className="grid-container">
                <div className="grid-x align-center">
                    <Wrapper className="cell">
                        <h1 className="h2 header">{t('privacy.heading')}</h1>
                        <Spacer size={20} />
                        <Tabs>
                            <Tab active={tab === 'app'} onClick={() => setTab('app')}>
                                {t('privacy.tabApp')}
                            </Tab>
                            <Tab active={tab === 'website'} onClick={() => setTab('website')}>
                                {t('privacy.tabWebsite')}
                            </Tab>
                        </Tabs>
                        <Spacer size={20} />
                        <Updated>{t('privacy.updated')}</Updated>
                        <LegalNotice />
                        <div
                            dangerouslySetInnerHTML={{
                                __html: tab === 'app' ? appPrivacy : websitePrivacy,
                            }}
                        ></div>
                    </Wrapper>
                </div>
                <Footer />
            </div>
        </>
    )
}
